import {
    Box,
    CircularProgress,
    Container,
    CssBaseline,
    ThemeProvider,
    Typography,
    createTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import SemanaDePosgradoTable from "./admin/tables/SemanaDePosgradoTable";
import Swal from "sweetalert2";

export const SemanaDePosgradoPanel = () => {

    const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);


    useEffect(() => {

        // Solicitar password
        (async () => {

            const { value: password } = await Swal.fire({
                title: 'Ingrese el password asignado.',
                input: 'password',
                // inputLabel: 'Password',
                inputPlaceholder: 'Password',
                inputAttributes: {
                maxlength: 8,
                autocapitalize: 'off',
                autocorrect: 'off'
                }
            })
            
            // Si el password es correcto
            if (password === 'Tec_2023') {
                setIsUserLoggedIn(true);
            } else {
                Swal.fire({
                    title: "El password es incorrecto.",
                    text: 'Confirme el dato y vuelva a intentarlo.',
                    icon: 'error',
                    confirmButtonText: 'Reintentar',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.replace('./panel');
                    }
                }); 
            }
        })()

    }, []);

    return isUserLoggedIn ? (
        <ThemeProvider theme={createTheme()}>
            <Container component="main" maxWidth="lg">
                <CssBaseline />
                <Box
                    sx={{
                        mt: 4,
                        mb: 4,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <Typography variant="h2">Semana de posgrado</Typography>
                    <Typography variant="h5" sx={{ mt: 2, mb: 0 }}>
                        Panel de consulta de registros
                    </Typography>
                </Box>

                {/* <Paper elevation={2} sx={{ p: 2, mb: 2 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} >
                            <SelectCustom
                                parentCallback={ yearSelected }
                                name={"year"}
                                label={"Edición del evento"}
                                variant={"standard"}
                                options={[
                                    {value:'2022', label:'2022'},
                                    {value:'2023', label:'2023'},
                                ]}
                            />
                        </Grid>

                    </Grid>
                </Paper> */}

                <SemanaDePosgradoTable year={"2023"} />
            </Container>
        </ThemeProvider>
    ) : (
        <>
            <CircularProgress color="inherit" sx={{ marginLeft: "48%", marginTop: "25%" }} />
        </>
    );
};
